import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  subModuleButtonColor: any;
  buttonColorName: any;
  moduleNameColor: any;
  private booleanValue: boolean = false;

  constructor() {
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.moduleNameColor = sessionStorage.getItem('moduleNameColor');
  }
  setBooleanValue(value: boolean) {
    this.booleanValue = value;
  }

  getBooleanValue(): boolean {
    return this.booleanValue;
  }
  changeSubMenuBackgroundColor(): void {
    const activeTab = document.getElementsByClassName('mdc-tab--active')[0];
    (activeTab as HTMLElement).style.backgroundColor = this.subModuleButtonColor;
    (activeTab as HTMLElement).classList.add('active-tab');
  }
  removeSubMenuPreviousActiveTabClass(): void {
    const previousActiveTab = document.getElementsByClassName('active-tab')[0];
    (previousActiveTab as HTMLElement).style.backgroundColor = '#E5E5E5';
    previousActiveTab.classList.remove('active-tab');
  }
  transform(value: string): string {
    switch (value) {
      case 'OnBoardingPending':
        return 'On-Boarding Pending';
      case 'Active':
        return 'Active';
      case 'Inactive':
        return 'Inactive';
      case 'Jan_Dec':
        return 'Jan-Dec';
      case 'Apr_Mar':
        return 'Apr-Mar';
      case 'July_Jun':
        return 'July-Jun';
      case 'Oct_Sep':
        return 'Oct-Sep';

      case "April-May":
        return 'Apr';
      case "May-June":
        return 'May';
      case "June-July":
        return "Jun";
      case "July-August":
        return "July"
      case "August-September":
        return "Aug"
      case "September-October":
        return "Sept";
      case "October-November":
        return "Oct"
      case "November-December":
        return "Nov";
      case "December-January":
        return "Dec"
      case "January-February":
        return "Jan";
      case "February-March":
        return "Feb";
      case "March-April":
        return "Mar";

      case "April-June":
        return "Apr-Jun";
      case "July-September":
        return "Jul-Sept";
      case "October-December":
        return "Oct-Dec";
      case "January-March":
        return "Jan-Mar";

      case "January-June":
        return "Jan-Jun";
      case "July-December":
        return "Jul-Dec";
      case "April-September":
        return "Apr-Sept";
      case "October-March":
        return "Oct-Mar";

      case "January-December":
        return "Jan-Dec";
      case "April-March":
        return "Apr-Mar";
      case "July-June":
        return "Jul-Jun";
      case "October-September":
        return "Oct-Sept";

      case "April":
        return 'Apr';
      case "May":
        return 'May';
      case "June":
        return "Jun";
      case "July":
        return "July"
      case "August":
        return "Aug"
      case "September":
        return "Sept";
      case "October":
        return "Oct"
      case "November":
        return "Nov";
      case "December":
        return "Dec"
      case "January":
        return "Jan";
      case "February":
        return "Feb";
      case "March":
        return "Mar";


      case "Apr":
        return 'April';
      case "May":
        return 'May';
      case "Jun":
        return "June";
      case "July":
        return "July"
      case "Aug":
        return "August"
      case "Sep":
        return "September";
      case "Oct":
        return "October"
      case "Nov":
        return "November";
      case "Dec":
        return "December"
      case "Jan":
        return "January";
      case "Feb":
        return "February";
      case "Mar":
        return "March";

      case "Semi_Annually":
        return "Semi-Annually"

      case "NotStarted":
        return "Not Started"
      case "PartiallyCompleted":
        return "Partially Completed"
      case "IncompleteAndEXPD":
        return "Incomplete & EXPD"

      case "Monthly_Cut_off":
        return "Monthly Cap"
      case "YTD_Cut_off":
        return "YTD Cap"
      default:
        return value;
    }
  }
  transformYearToFyFormat(value: string) {
    if(value==undefined){
      return
    }
    const [startYear, endYear] = value?.split('-');
    if (startYear == endYear) {
      return `${startYear}`;
    } else {
      return `FY ${startYear}-${endYear?.slice(-2)}`;
    }
  }
  transformYearToYTDFormat(value: string) {
    if(value==undefined){
      return
    }
    const [startYear, endYear] = value?.split('-');
    if (startYear == endYear) {
      return `${startYear}`;
    } else {
      return `YTD ${startYear}-${endYear?.slice(-2)}`;
    }
  }
  formatDecimalValue(value: number) {
    // Check if the value has a fractional part
    if (value % 1 !== 0) {
      // Apply toFixed(2) if it's a decimal
      return parseFloat(value?.toFixed(2));
    } else {
      // Return the value as a string without modification
      return value;
    }
  }

  transformNumber(value: any): string {
    if (value === null || value === undefined || isNaN(value)) {
      return '-'; // Return a placeholder if the value is invalid
    }

    const number = parseFloat(value);

    if (number >= 10000000) {
      // Convert to Crores
      return (number / 10000000).toFixed(4) + ' Cr';
    } else if (number >= 100000) {
      // Convert to Lakhs
      return (number / 100000).toFixed(4) + ' L';
    } else if (number >= 1000) {
      // Convert to Thousands
      return (number / 1000).toFixed(4) + ' K';
    } else {
      return number.toFixed(4);
    }
  }
}
